"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bucketsArchiveWatch = exports.bucketsArchiveInfo = exports.bucketsArchiveStatus = exports.bucketsArchive = exports.bucketsRemovePath = exports.bucketsRemove = exports.bucketsPullIpfsPath = exports.bucketsPullPath = exports.bucketsPushPath = exports.bucketsListIpfsPath = exports.bucketsListPath = exports.bucketsList = exports.bucketsLinks = exports.bucketsRoot = exports.bucketsInit = void 0;
const loglevel_1 = __importDefault(require("loglevel"));
const buckets_pb_1 = require("@textile/buckets-grpc/buckets_pb");
const buckets_pb_service_1 = require("@textile/buckets-grpc/buckets_pb_service");
const cids_1 = __importDefault(require("cids"));
const event_iterator_1 = require("event-iterator");
const next_tick_1 = __importDefault(require("next-tick"));
const grpc_web_1 = require("@improbable-eng/grpc-web");
const normalize_1 = require("./normalize");
const logger = loglevel_1.default.getLogger('buckets-api');
const convertRootObject = (root) => {
    return {
        key: root.getKey(),
        name: root.getName(),
        path: root.getPath(),
        createdAt: root.getCreatedat(),
        updatedAt: root.getUpdatedat(),
        thread: root.getThread(),
    };
};
const convertRootObjectNullable = (root) => {
    if (!root)
        return;
    return convertRootObject(root);
};
const convertPathItem = (item) => {
    const list = item.getItemsList();
    return {
        cid: item.getCid(),
        name: item.getName(),
        path: item.getPath(),
        size: item.getSize(),
        isdir: item.getIsdir(),
        itemsList: list ? list.map(convertPathItem) : [],
    };
};
const convertPathItemNullable = (item) => {
    if (!item)
        return;
    return convertPathItem(item);
};
/**
 * Initializes a new bucket.
 * @public
 * @param name Human-readable bucket name. It is only meant to help identify a bucket in a UI and is not unique.
 * @param isPrivate encrypt the bucket contents (default `false`)
 * @example
 * Initialize a Bucket called "app-name-files"
 * ```tyepscript
 * import { Buckets } from '@textile/hub'
 *
 * const init = async (buckets: Buckets) => {
 *     return buckets.init("app-name-files")
 * }
 * ```
 *
 * @internal
 */
function bucketsInit(api, name, isPrivate = false, ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        logger.debug('init request');
        const req = new buckets_pb_1.InitRequest();
        req.setName(name);
        req.setPrivate(isPrivate);
        const res = yield api.unary(buckets_pb_service_1.API.Init, req, ctx);
        const links = res.getLinks();
        return {
            seed: res.getSeed_asU8(),
            seedCid: res.getSeedcid(),
            root: convertRootObjectNullable(res.getRoot()),
            links: links ? links.toObject() : undefined,
        };
    });
}
exports.bucketsInit = bucketsInit;
/**
 * Returns the bucket root CID
 * @param key Unique (IPNS compatible) identifier key for a bucket.
 *
 * @internal
 */
function bucketsRoot(api, key, ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        logger.debug('root request');
        const req = new buckets_pb_1.RootRequest();
        req.setKey(key);
        const res = yield api.unary(buckets_pb_service_1.API.Root, req, ctx);
        return convertRootObjectNullable(res.getRoot());
    });
}
exports.bucketsRoot = bucketsRoot;
/**
 * Returns a list of bucket links.
 * @param key Unique (IPNS compatible) identifier key for a bucket.
 * @example
 * Generate the HTTP, IPNS, and IPFS links for a Bucket
 * ```tyepscript
 * import { Buckets } from '@textile/hub'
 *
 * const getLinks = async (buckets: Buckets) => {
 *    const links = buckets.links(bucketKey)
 *    return links.ipfs
 * }
 *
 * const getIpfs = async (buckets: Buckets) => {
 *    const links = buckets.links(bucketKey)
 *    return links.ipfs
 * }
 * ```
 *
 * @internal
 */
function bucketsLinks(api, key, ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        logger.debug('link request');
        const req = new buckets_pb_1.LinksRequest();
        req.setKey(key);
        const res = yield api.unary(buckets_pb_service_1.API.Links, req, ctx);
        return res.toObject();
    });
}
exports.bucketsLinks = bucketsLinks;
/**
 * Returns a list of all bucket roots.
 * @example
 * Find an existing Bucket named "app-name-files"
 * ```typescript
 * import { Buckets } from '@textile/hub'
 *
 * const exists = async (buckets: Buckets) => {
 *     const roots = await buckets.list();
 *     return roots.find((bucket) => bucket.name ===  "app-name-files")
 * }
 * ```
 *
 * @internal
 */
function bucketsList(api, ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        logger.debug('list request');
        const req = new buckets_pb_1.ListRequest();
        const res = yield api.unary(buckets_pb_service_1.API.List, req, ctx);
        const roots = res.getRootsList();
        const map = roots ? roots.map((m) => m).map((m) => convertRootObject(m)) : [];
        return map;
    });
}
exports.bucketsList = bucketsList;
/**
 * Returns information about a bucket path.
 * @param key Unique (IPNS compatible) identifier key for a bucket.
 * @param path A file/object (sub)-path within a bucket.
 *
 * @internal
 */
function bucketsListPath(api, key, path, ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        logger.debug('list path request');
        const req = new buckets_pb_1.ListPathRequest();
        req.setKey(key);
        req.setPath(path);
        const res = yield api.unary(buckets_pb_service_1.API.ListPath, req, ctx);
        return {
            item: convertPathItemNullable(res.getItem()),
            root: convertRootObjectNullable(res.getRoot()),
        };
    });
}
exports.bucketsListPath = bucketsListPath;
/**
 * listIpfsPath returns items at a particular path in a UnixFS path living in the IPFS network.
 * @param path UnixFS path
 *
 * @internal
 */
function bucketsListIpfsPath(api, path, ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        logger.debug('list path request');
        const req = new buckets_pb_1.ListIpfsPathRequest();
        req.setPath(path);
        const res = yield api.unary(buckets_pb_service_1.API.ListIpfsPath, req, ctx);
        return convertPathItemNullable(res.getItem());
    });
}
exports.bucketsListIpfsPath = bucketsListIpfsPath;
/**
 * Pushes a file to a bucket path.
 * @param key Unique (IPNS compatible) identifier key for a bucket.
 * @param path A file/object (sub)-path within a bucket.
 * @param input The input file/stream/object.
 * @param opts Options to control response stream. Currently only supports a progress function.
 * @remarks
 * This will return the resolved path and the bucket's new root path.
 * Data must be broken into <4mb chunks. See bufToArray() for help.
 * @example
 * Push a file to the root of a bucket
 * ```tyepscript
 * import { Buckets } from '@textile/hub'
 *
 * const pushFile = async (content: string, bucketKey: string) => {
 *    const file = { path: '/index.html', content: Buffer.from(content) }
 *    return await buckets.pushPath(bucketKey!, 'index.html', file)
 * }
 * ```
 *
 * @internal
 */
function bucketsPushPath(api, key, path, input, opts, ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            var e_1, _a;
            // Only process the first  input if there are more than one
            const source = (yield normalize_1.normaliseInput(input).next()).value;
            const client = grpc_web_1.grpc.client(buckets_pb_service_1.API.PushPath, {
                host: api.serviceHost,
                transport: api.rpcOptions.transport,
                debug: api.rpcOptions.debug,
            });
            client.onMessage((message) => {
                var _a, _b, _c;
                if (message.hasError()) {
                    // Reject on first error
                    reject(new Error(message.getError()));
                }
                else if (message.hasEvent()) {
                    const event = (_a = message.getEvent()) === null || _a === void 0 ? void 0 : _a.toObject();
                    if (event === null || event === void 0 ? void 0 : event.path) {
                        // @todo: Is there an standard library/tool for this step in JS?
                        const pth = event.path.startsWith('/ipfs/') ? event.path.split('/ipfs/')[1] : event.path;
                        const cid = new cids_1.default(pth);
                        const res = {
                            path: {
                                path: `/ipfs/${cid.toString()}`,
                                cid: cid,
                                root: cid,
                                remainder: '',
                            },
                            root: (_c = (_b = event.root) === null || _b === void 0 ? void 0 : _b.path) !== null && _c !== void 0 ? _c : '',
                        };
                        resolve(res);
                    }
                    else if (opts === null || opts === void 0 ? void 0 : opts.progress) {
                        opts.progress(event === null || event === void 0 ? void 0 : event.bytes);
                    }
                }
                else {
                    reject(new Error('Invalid reply'));
                }
            });
            client.onEnd((code) => {
                if (code === grpc_web_1.grpc.Code.OK) {
                    resolve();
                }
                else {
                    reject(new Error(code.toString()));
                }
            });
            if (source) {
                const head = new buckets_pb_1.PushPathRequest.Header();
                head.setPath(source.path || path);
                head.setKey(key);
                const req = new buckets_pb_1.PushPathRequest();
                req.setHeader(head);
                const metadata = Object.assign(Object.assign({}, api.context.toJSON()), ctx === null || ctx === void 0 ? void 0 : ctx.toJSON());
                client.start(metadata);
                client.send(req);
                if (source.content) {
                    try {
                        for (var _b = __asyncValues(source.content), _c; _c = yield _b.next(), !_c.done;) {
                            const chunk = _c.value;
                            const part = new buckets_pb_1.PushPathRequest();
                            part.setChunk(chunk);
                            client.send(part);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) yield _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    client.finishSend();
                }
            }
        }));
    });
}
exports.bucketsPushPath = bucketsPushPath;
/**
 * Pulls the bucket path, returning the bytes of the given file.
 * @param key Unique (IPNS compatible) identifier key for a bucket.
 * @param path A file/object (sub)-path within a bucket.
 * @param opts Options to control response stream. Currently only supports a progress function.
 *
 * @internal
 */
function bucketsPullPath(api, key, path, opts, ctx) {
    const metadata = Object.assign(Object.assign({}, api.context.toJSON()), ctx === null || ctx === void 0 ? void 0 : ctx.toJSON());
    const request = new buckets_pb_1.PullPathRequest();
    request.setKey(key);
    request.setPath(path);
    let written = 0;
    const events = new event_iterator_1.EventIterator(({ push, stop, fail }) => {
        const resp = grpc_web_1.grpc.invoke(buckets_pb_service_1.API.PullPath, {
            host: api.serviceHost,
            transport: api.rpcOptions.transport,
            debug: api.rpcOptions.debug,
            request,
            metadata,
            onMessage: (res) => __awaiter(this, void 0, void 0, function* () {
                const chunk = res.getChunk_asU8();
                push(chunk);
                written += chunk.byteLength;
                if (opts === null || opts === void 0 ? void 0 : opts.progress) {
                    opts.progress(written);
                }
            }),
            onEnd: (status, message, _trailers) => __awaiter(this, void 0, void 0, function* () {
                if (status !== grpc_web_1.grpc.Code.OK) {
                    fail(new Error(message));
                }
                stop();
            }),
        });
        return () => resp.close();
    });
    const it = Object.assign({ [Symbol.asyncIterator]() {
            return this;
        } }, events[Symbol.asyncIterator]());
    return it;
}
exports.bucketsPullPath = bucketsPullPath;
/**
 * pullIpfsPath pulls the path from a remote UnixFS dag, writing it to writer if it's a file.
 * @param path A file/object (sub)-path within a bucket.
 * @param opts Options to control response stream. Currently only supports a progress function.
 *
 * @internal
 */
function bucketsPullIpfsPath(api, path, opts, ctx) {
    const metadata = Object.assign(Object.assign({}, api.context.toJSON()), ctx === null || ctx === void 0 ? void 0 : ctx.toJSON());
    const request = new buckets_pb_1.PullIpfsPathRequest();
    request.setPath(path);
    let written = 0;
    const events = new event_iterator_1.EventIterator(({ push, stop, fail }) => {
        const resp = grpc_web_1.grpc.invoke(buckets_pb_service_1.API.PullIpfsPath, {
            host: api.serviceHost,
            transport: api.rpcOptions.transport,
            debug: api.rpcOptions.debug,
            request,
            metadata,
            onMessage: (res) => __awaiter(this, void 0, void 0, function* () {
                const chunk = res.getChunk_asU8();
                push(chunk);
                written += chunk.byteLength;
                if (opts === null || opts === void 0 ? void 0 : opts.progress) {
                    opts.progress(written);
                }
            }),
            onEnd: (status, message, _trailers) => __awaiter(this, void 0, void 0, function* () {
                if (status !== grpc_web_1.grpc.Code.OK) {
                    fail(new Error(message));
                }
                stop();
            }),
        });
        return () => resp.close();
    });
    const it = Object.assign({ [Symbol.asyncIterator]() {
            return this;
        } }, events[Symbol.asyncIterator]());
    return it;
}
exports.bucketsPullIpfsPath = bucketsPullIpfsPath;
/**
 * Removes an entire bucket. Files and directories will be unpinned.
 * @param key Unique (IPNS compatible) identifier key for a bucket.
 *
 * @internal
 */
function bucketsRemove(api, key, ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        logger.debug('remove request');
        const req = new buckets_pb_1.RemoveRequest();
        req.setKey(key);
        yield api.unary(buckets_pb_service_1.API.Remove, req, ctx);
        return;
    });
}
exports.bucketsRemove = bucketsRemove;
/**
 * Returns information about a bucket path.
 * @param key Unique (IPNS compatible) identifier key for a bucket.
 * @param path A file/object (sub)-path within a bucket.
 * @param root optional to specify a root
 *
 * @internal
 */
function bucketsRemovePath(api, key, path, root, ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        logger.debug('remove path request');
        const req = new buckets_pb_1.RemovePathRequest();
        req.setKey(key);
        req.setPath(path);
        if (root)
            req.setRoot(root);
        yield api.unary(buckets_pb_service_1.API.RemovePath, req, ctx);
        return;
    });
}
exports.bucketsRemovePath = bucketsRemovePath;
/**
 * archive creates a Filecoin bucket archive via Powergate.
 * @internal
 * @param key Unique (IPNS compatible) identifier key for a bucket.
 */
function bucketsArchive(api, key, ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        logger.debug('archive request');
        const req = new buckets_pb_1.ArchiveRequest();
        req.setKey(key);
        yield api.unary(buckets_pb_service_1.API.Archive, req, ctx);
        return;
    });
}
exports.bucketsArchive = bucketsArchive;
/**
 * archiveStatus returns the status of a Filecoin bucket archive.
 * @internal
 * @param key Unique (IPNS compatible) identifier key for a bucket.
 */
function bucketsArchiveStatus(api, key, ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        logger.debug('archive status request');
        const req = new buckets_pb_1.ArchiveStatusRequest();
        req.setKey(key);
        const res = yield api.unary(buckets_pb_service_1.API.ArchiveStatus, req, ctx);
        return res.toObject();
    });
}
exports.bucketsArchiveStatus = bucketsArchiveStatus;
/**
 * archiveInfo returns info about a Filecoin bucket archive.
 * @internal
 * @param key Unique (IPNS compatible) identifier key for a bucket.
 */
function bucketsArchiveInfo(api, key, ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        logger.debug('archive info request');
        const req = new buckets_pb_1.ArchiveInfoRequest();
        req.setKey(key);
        const res = yield api.unary(buckets_pb_service_1.API.ArchiveInfo, req, ctx);
        return res.toObject();
    });
}
exports.bucketsArchiveInfo = bucketsArchiveInfo;
/**
 * archiveWatch watches status events from a Filecoin bucket archive.
 * @internal
 * @param key Unique (IPNS compatible) identifier key for a bucket.
 */
function bucketsArchiveWatch(api, key, callback, ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        logger.debug('archive watch request');
        const req = new buckets_pb_1.ArchiveWatchRequest();
        req.setKey(key);
        const metadata = Object.assign(Object.assign({}, api.context.toJSON()), ctx === null || ctx === void 0 ? void 0 : ctx.toJSON());
        const res = grpc_web_1.grpc.invoke(buckets_pb_service_1.API.ArchiveWatch, {
            host: api.context.host,
            request: req,
            metadata,
            onMessage: (rec) => {
                const response = {
                    id: rec.getJsPbMessageId(),
                    msg: rec.getMsg(),
                };
                next_tick_1.default(() => callback(response));
            },
            onEnd: (status, message, _trailers) => {
                if (status !== grpc_web_1.grpc.Code.OK) {
                    return callback(undefined, new Error(message));
                }
                callback();
            },
        });
        return res.close.bind(res);
    });
}
exports.bucketsArchiveWatch = bucketsArchiveWatch;
//# sourceMappingURL=index.js.map